import React, { useRef, useState } from 'react';
import { Box, Button, Flex, Heading, HStack, Icon, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { PhoneIcon, MapPinIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { brand, images, whatsappHref } from '../data/brand';
const MotionBox = motion(Box);
const trustItems = [{
  icon: MapPinIcon,
  label: 'Miami, Florida'
}, {
  icon: ShieldCheckIcon,
  label: 'Consultas confidenciales'
}, {
  icon: ClockIcon,
  label: 'Atención por WhatsApp y teléfono'
}];
export function Hero() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [glow, setGlow] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const handleMove = (event: React.MouseEvent<HTMLDivElement>) => {
    const bounds = heroRef.current?.getBoundingClientRect();
    if (!bounds) return;
    setGlow({
      x: event.clientX - bounds.left,
      y: event.clientY - bounds.top
    });
  };
  return <Box as="section" id="inicio" ref={heroRef} onMouseMove={handleMove} onMouseLeave={() => setGlow(null)} position="relative" bg="ink.900" overflow="hidden" data-id="element-113" data-mp="3j8sd1u7lx7mo">
      {/* Cursor comet trail */}
      {glow && <MotionBox position="absolute" left={0} top={0} w="22rem" h="22rem" borderRadius="full" pointerEvents="none" zIndex={1} display={{
      base: 'none',
      md: 'block'
    }} bg="radial-gradient(circle, rgba(242,183,5,0.18) 0%, rgba(242,183,5,0.06) 40%, rgba(242,183,5,0) 70%)" animate={{
      x: glow.x - 176,
      y: glow.y - 176
    }} transition={{
      type: 'spring',
      stiffness: 60,
      damping: 18,
      mass: 0.6
    }} data-id="element-114" data-mp="39a32ynlycrgz" />}

      <Flex direction={{
      base: 'column',
      lg: 'row'
    }} align="stretch" position="relative" data-id="element-115" data-mp="2hj5clq725iyo">
        {/* 60% — editorial text column on charcoal with smoke texture */}
        <Box w={{
        base: '100%',
        lg: '60%'
      }} position="relative" px={{
        base: 5,
        md: 10,
        xl: 16
      }} pt={{
        base: 16,
        md: 20,
        lg: 28
      }} pb={{
        base: 12,
        lg: 28
      }} zIndex={2} data-id="element-116" data-mp="2ljz1alsbr1sm">
          <Box position="absolute" inset={0} opacity={0.5} pointerEvents="none" aria-hidden="true" bg="radial-gradient(60% 50% at 20% 25%, rgba(196,18,48,0.22) 0%, rgba(13,13,13,0) 70%), radial-gradient(50% 45% at 75% 80%, rgba(242,183,5,0.12) 0%, rgba(13,13,13,0) 70%)" animation="smokeDriftA 22s ease-in-out infinite" data-id="element-117" data-mp="ibyq2dugb42p" />

          <VStack align="flex-start" spacing={{
          base: 6,
          md: 7
        }} position="relative" maxW="34rem" data-id="element-118" data-mp="111yd6v6qe93h">
            <HStack spacing={3} data-id="element-119" data-mp="x1w6g7m52phc">
              <Box w="2.5rem" h="1px" bg="gold.400" data-id="element-120" data-mp="x0uwk6gv0917" />
              <Text fontSize="xs" fontWeight={700} letterSpacing="0.32em" textTransform="uppercase" color="gold.400" data-id="element-121" data-mp="3ltgmzq8oqqoc">
                Templo de Ayuda Esotérica
              </Text>
            </HStack>

            <Heading as="h1" fontSize={{
            base: '2.3rem',
            sm: '3rem',
            md: '3.9rem',
            xl: '4.4rem'
          }} color="gold.300" letterSpacing="-0.02em" sx={{
            animation: 'neonFlicker 6s ease-in-out infinite'
          }} data-id="element-122" data-mp="21aehzejeah9k">
              AMARRES DE AMOR Y HECHIZOS MÁGICOS:{' '}
              <Text as="span" color="crimson.500" fontStyle="italic" fontWeight={500} data-id="element-123" data-mp="2fzanp4xzbi70">
                Orientación Espiritual
              </Text>
            </Heading>

            <Text fontFamily="heading" fontSize={{
            base: 'xl',
            md: '2xl'
          }} fontStyle="italic" color="cream.100" data-id="element-124" data-mp="2p08u1tvw41sr">
              Nuestros guías espirituales iluminan tu camino.
            </Text>

            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="cream.200" opacity={0.85} data-id="element-125" data-mp="uou0t33o7k89">
              Somos especialistas en prácticas espirituales, hechizos y amarres tradicionales. A
              través de nuestra experiencia y orientación personalizada, ofrecemos acompañamiento
              para quienes desean explorar diferentes aspectos de su vida personal y sentimental.
            </Text>

            <Stack direction={{
            base: 'column',
            sm: 'row'
          }} spacing={3} w={{
            base: '100%',
            sm: 'auto'
          }} pt={1} data-id="element-126" data-mp="9ah4l81k8u0a">
              <Button as="a" href={whatsappHref()} target="_blank" rel="noopener noreferrer" variant="whatsapp" h={{
              base: '3.5rem',
              md: '3.85rem'
            }} px={8} fontSize={{
              base: 'sm',
              md: 'md'
            }} leftIcon={<WhatsAppIcon size={21} data-id="element-128" data-mp="2yzj0tqad8uo6" />} data-id="element-127" data-mp="3ho68mgjxfy5g">
                CONSULTAR POR WHATSAPP
              </Button>
              <Button as="a" href={brand.phoneHref} variant="goldOutline" h={{
              base: '3.5rem',
              md: '3.85rem'
            }} px={8} fontSize={{
              base: 'sm',
              md: 'md'
            }} leftIcon={<PhoneIcon size={18} aria-hidden="true" data-id="element-130" data-mp="zkhk7tyrc2zi" />} data-id="element-129" data-mp="2u1hi56guqxd8">
                LLAMAR AHORA
              </Button>
            </Stack>

            <Stack direction={{
            base: 'column',
            md: 'row'
          }} spacing={{
            base: 2,
            md: 6
          }} pt={{
            base: 2,
            md: 4
          }} data-id="element-131" data-mp="14klyddc70lmk">
              {trustItems.map(item => <HStack key={item.label} spacing={2} data-id="element-132" data-mp="1x7q099fzoju4">
                  <Icon as={item.icon} boxSize="1rem" color="crimson.500" aria-hidden="true" data-id="element-133" data-mp="1j902drlcig4p" />
                  <Text fontSize="sm" color="cream.200" opacity={0.8} data-id="element-134" data-mp="1n9sd6p9v8t33">
                    {item.label}
                  </Text>
                </HStack>)}
            </Stack>
          </VStack>
        </Box>

        {/* 40% — candle image in a diagonally clipped frame bleeding off the edge */}
        <Box w={{
        base: '100%',
        lg: '43%'
      }} position="relative" minH={{
        base: '20rem',
        md: '26rem',
        lg: 'auto'
      }} ml={{
        lg: '-3%'
      }} mr={{
        lg: '-2rem'
      }} my={{
        lg: 6
      }} sx={{
        clipPath: {
          base: 'polygon(0 6%, 100% 0, 100% 100%, 0 94%)',
          lg: 'polygon(18% 0, 100% 0, 100% 88%, 82% 100%, 0 100%, 0 12%)'
        }
      }} data-id="element-135" data-mp="2ei3lhtivjn9s">
          <Image src={images.hero} alt="Altar con velas encendidas, cristales de cuarzo y una luna dorada" w="100%" h="100%" minH={{
          base: '20rem',
          md: '26rem'
        }} objectFit="cover" data-id="element-136" data-mp="1vsdvdjq23po7" />
          <Box position="absolute" inset={0} bg="linear-gradient(115deg, rgba(13,13,13,0.85) 0%, rgba(13,13,13,0.25) 45%, rgba(196,18,48,0.2) 100%)" aria-hidden="true" data-id="element-137" data-mp="1guv8yo0upojx" />
          <Box position="absolute" inset={0} border="1px solid" borderColor="rgba(242,183,5,0.35)" pointerEvents="none" aria-hidden="true" data-id="element-138" data-mp="3b8md580evg7z" />
        </Box>
      </Flex>
    </Box>;
}